'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$v = require('./styles-23854021.js');

var Collapsible = function (_a) {
    var title = _a.title, children = _a.children, isOpened = _a.isOpened, toggle = _a.onToggle;
    var handleButtonKeyDown = React.useCallback(function (event) {
        event.stopPropagation();
    }, []);
    return (React__default.createElement(styles$v.Container, { "data-testid": "collapsible" },
        React__default.createElement(styles$v.Title, { onClick: toggle, onKeyDown: handleButtonKeyDown, className: "title", "data-testid": "collapsible-title" },
            title,
            React__default.createElement(styles$v.CaretStyled, { isOpen: isOpened, size: "xs", variant: "adminGreyDark", className: "caret" })),
        React__default.createElement(styles$v.Content, { isOpen: isOpened }, children)));
};

exports.Collapsible = Collapsible;
